export default "__VITE_ASSET__CbAnuZ7C__"